module.exports = __webpack_public_path__ + "static/new-9a7f8d10a88f6557a5d47f7a8fa48bf5.png";